"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const operator_attendance_types_1 = require("./operator-attendance.types");
const op_attendance_1 = require("services/report/op-attendance");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, op_attendance_1._getAllDataOperatorAttendance)(dataStates);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: operator_attendance_types_1.operatorAttendanceTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.data.map(item => {
                return Object.assign(Object.assign({}, item), { login_time: item.login_time === '' ? '' : new Date(item.login_time), logout_time: item.logout_time === '' ? '' : new Date(item.logout_time) });
            })
        };
        dispatch({ type: operator_attendance_types_1.operatorAttendanceTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield (0, op_attendance_1._getAllDataOperatorAttendance)(dataStates);
    const payload = {
        dataGrid: res.isError ? [] : res.data.map(item => {
            return Object.assign(Object.assign({}, item), { login_time: item.login_time === '' ? '' : new Date(item.login_time), logout_time: item.logout_time === '' ? '' : new Date(item.logout_time) });
        }),
        dataStates
    };
    dispatch({ type: operator_attendance_types_1.operatorAttendanceTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: operator_attendance_types_1.operatorAttendanceTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: operator_attendance_types_1.operatorAttendanceTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: operator_attendance_types_1.operatorAttendanceTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: operator_attendance_types_1.operatorAttendanceTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const exportDocuments = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, op_attendance_1._exportReportOperatorAttendance)(dataStates);
    if (response.isError) {
        dispatch({
            type: operator_attendance_types_1.operatorAttendanceTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        dispatch({ type: operator_attendance_types_1.operatorAttendanceTypes.SET_EXPORT_DOCUMENTS_URL, payload: response });
    }
});
const clearDocuments = () => dispatch => {
    dispatch({ type: operator_attendance_types_1.operatorAttendanceTypes.CLEAR_EXPORT_DOCUMENTS_URL, payload: '' });
};
exports.default = {
    getDataGrid,
    onSortChange,
    onCloseError,
    onFilterChange,
    onClickMutation,
    onDataStateChange,
    exportDocuments,
    clearDocuments
};
